import {
  Component,
  ElementRef,
  OnInit,
  Input,
  ViewChild,
  Self,
  Output,
  EventEmitter,
} from '@angular/core';
import { AbstractControl, Validators, NgControl, ControlValueAccessor } from '@angular/forms';

@Component({
  selector: 'app-custom-textarea',
  templateUrl: 'custom-textarea.component.html',
  styleUrls: ['custom-textarea.component.scss'],
})
export class CustomTextareaComponent implements ControlValueAccessor, OnInit {
  /* tslint:disable-next-line:no-input-rename */
  @Input('label') label?: string = null;
  @ViewChild('textarea') textarea: ElementRef<HTMLTextAreaElement>;
  disabled: boolean;
  /* tslint:disable-next-line:no-input-rename */
  @Input('id') id = '';
  /* tslint:disable-next-line:no-input-rename */
  @Input('name') name = '';
  /* tslint:disable-next-line:no-input-rename */
  @Input('display') display = false;
  // utilizado apenas para os campos do curso
  /* tslint:disable-next-line:no-input-rename */
  @Input('alias') alias?: string;
  @Output() campoAdicionado ?= new EventEmitter<any>();

  onChange: any = () => { };
  onTouched: any = () => { };

  constructor(@Self() public controlDir: NgControl) {
    controlDir.valueAccessor = this;
  }

  ngOnInit() {
    const control = this.controlDir.control;
    const validators = control.validator
      ? [control.validator, Validators.maxLength(5000)]
      : Validators.maxLength(5000);
    control.setValidators(validators);
    control.updateValueAndValidity();
  }

  writeValue(value: any) {
    // write value to view
    if (value) {
      this.textarea.nativeElement.value = value;
    }
  }

  registerOnChange(fn: (value: any) => void) {
    // save callback to call on change
    this.onChange = fn;
  }

  registerOnTouched(fn: (value: any) => void) {
    // save callback to call when touched
    this.onTouched = fn;
  }

  setDisableState(disabled: boolean): void {
    // disable or enable the field
    this.disabled = disabled;
  }

  validate(ctrl: AbstractControl) {
    if (this.textarea.nativeElement.value) {
      return Validators.required(ctrl);
    }
  }

  addField() {
    this.display = true;
    if (this.alias) {
      this.campoAdicionado.emit(this.alias);
    }
    const control = this.controlDir.control;
    const validators = control.validator
      ? [control.validator, Validators.required]
      : [Validators.maxLength(5000), Validators.required];
    control.setValidators(validators);
    control.updateValueAndValidity();
  }

  removeField() {
    this.display = false;
    if (this.alias) {
      this.campoAdicionado.emit(this.alias);
    }
    const control = this.controlDir.control;
    control.clearValidators();
    control.updateValueAndValidity();
  }
}
